import { createSchemaBasedConstructor } from './create-typed-constructor'

const BoundsPolygon = createSchemaBasedConstructor('BoundsPolygon')

export default BoundsPolygon
